
export class Model_CRM_Opportunity_Rolls {
    public RollId: number;
    public RollName: string;
}